/**
 * This file is auto-generated from ChatView.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const typeAnswer: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Type your answer...';
        case 'pl':
            return 'Wpisz odpowiedź...';
    }
};
